import { z } from 'zod';

import { normalizeScheduleTimeToHHMM } from '../../utils/date-utils';

const scheduleDaySchema = z.object({
  dayNumber: z.number().int().min(1).max(7),
  weekNumber: z.number().int().min(-1).max(52),
  startTime: z.string()
});

export const assignmentScheduleBaseObject = z.object({
  startDate: z
    .string()
    .min(1, 'Укажите дату начала расписания')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Некорректный формат даты начала расписания'),
  periodValue: z.number().positive(),
  periodType: z.number().min(1).max(3),
  daysLookback: z.number().int().min(1),
  scheduleSettings: z.array(scheduleDaySchema).min(1)
});

export const DUPLICATE_SCHEDULE_DAY_MESSAGE =
  'Не допускаются полностью совпадающие строки (номер дня, номер недели, время запуска)';

export function refineNoDuplicateScheduleDays(
  data: { scheduleSettings: z.infer<typeof scheduleDaySchema>[] },
  ctx: z.RefinementCtx
): void {
  const seen = new Map<string, number>();
  data.scheduleSettings.forEach((row, idx) => {
    const key = `${row.dayNumber}|${
      row.weekNumber
    }|${normalizeScheduleTimeToHHMM(row.startTime)}`;
    const firstIdx = seen.get(key);
    if (firstIdx !== undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: DUPLICATE_SCHEDULE_DAY_MESSAGE,
        path: ['scheduleSettings', idx]
      });
    } else {
      seen.set(key, idx);
    }
  });
}

export const AssignmentScheduleSchema =
  assignmentScheduleBaseObject.superRefine(refineNoDuplicateScheduleDays);

export const EmployeeAssignmentScheduleSettingSchema =
  assignmentScheduleBaseObject
    .extend({
      id: z.number().optional(),
      departmentId: z.number().optional()
    })
    .superRefine(refineNoDuplicateScheduleDays);
